<template>
  <warehouse-detail :is-edit='true'>
  </warehouse-detail>
</template>

<script>
import WarehouseDetail from '../components/WarehouseDetail'
export default {
  name: 'EditWarehouse',
  components: {
    WarehouseDetail
  }
}
</script>

